import ExportToExcelButton from '@crema/core/AppExportExeclFile';
import {Box, Typography} from '@mui/material';
import PropsType from 'prop-types';
import Matrix from '../Matrix';
import {green} from '@mui/material/colors';
const MatrixForBDAPI = ({
  allStatusCountDB,
  doneStatusCountDB,
  errorStatusCountDB,
  errorDataDB,
  allStatusCountAPI,
  doneStatusCountAPI,
  errorStatusCountAPI,
  errorDataAPI,
  messages,
  fileName,
  isClicked,
  hasSuccessfulData,
}) => {
  return (
    <>
      {isClicked ? (
        <Matrix
          title={messages['addData.DB']}
          doneStatusCount={doneStatusCountDB}
          errorStatusCount={errorStatusCountDB}
          allStatusCount={allStatusCountDB}
          messages={messages}
        />
      ) : (
        ''
      )}
      {errorStatusCountDB > 0 ? (
        <ExportToExcelButton fileName={fileName} json_data={errorDataDB} />
      ) : isClicked ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            ml: 'auto',
            mt: '1rem',
            color: doneStatusCountDB > 0 ? green[500] : 'orange',
          }}
        >
          <Typography>
            {doneStatusCountDB > 0
              ? 'Data uploaded successfully!'
              : 'No new data uploaded (all were duplicates or errors)'}
          </Typography>
        </Box>
      ) : null}

      {isClicked && hasSuccessfulData ? (
        <Matrix
          title={messages['addData.API']}
          doneStatusCount={doneStatusCountAPI}
          errorStatusCount={errorStatusCountAPI}
          allStatusCount={allStatusCountAPI}
          messages={messages}
        />
      ) : isClicked && !hasSuccessfulData ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            ml: 'auto',
            mt: '1rem',
            color: 'orange',
            backgroundColor: '#fff3cd',
            padding: '12px',
            borderRadius: '4px',
            border: '1px solid #ffeaa7',
          }}
        >
          <Typography>
            No successful data to send to API. All records failed validation or
            database upload.
          </Typography>
        </Box>
      ) : null}
      {errorStatusCountAPI > 0 ? (
        <ExportToExcelButton fileName={fileName} json_data={errorDataAPI} />
      ) : isClicked && hasSuccessfulData ? (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            ml: 'auto',
            mt: '1rem',
            color: green[500],
          }}
        >
          <Typography>Data sent successfully!</Typography>
        </Box>
      ) : null}
    </>
  );
};

MatrixForBDAPI.propTypes = {
  allStatusCountDB: PropsType.number.isRequired,
  doneStatusCountDB: PropsType.number.isRequired,
  errorStatusCountDB: PropsType.number.isRequired,
  errorDataDB: PropsType.array.isRequired,
  allStatusCountAPI: PropsType.number.isRequired,
  doneStatusCountAPI: PropsType.number.isRequired,
  errorStatusCountAPI: PropsType.number.isRequired,
  errorDataAPI: PropsType.array.isRequired,
  messages: PropsType.object.isRequired,
  fileName: PropsType.string.isRequired,
  isClicked: PropsType.bool.isRequired,
  hasSuccessfulData: PropsType.bool,
};
export default MatrixForBDAPI;
